// Countries a specialty can be grouped under in the admin panel.
// Synced with: functions/modules/config/countries.js

import { TURKIYE_ENABLED } from '../config/features';

export type SpecialtyCountry = 'AU' | 'TR';

/** Every country the codebase knows about, live or not. */
const ALL_SPECIALTY_COUNTRIES: SpecialtyCountry[] = ['AU', 'TR'];

/**
 * Countries a practitioner can pick at signup and an admin can file a
 * specialty under. Turkey is behind the Türkiye gate, so with the flag off the
 * practice-country picker, the admin panel's country dropdowns and the signup
 * Zod enum all narrow to Australia together.
 *
 * The type stays 'AU' | 'TR' on purpose. Existing Turkish specialty documents
 * still have to be readable and labellable when the gate is off; what the gate
 * withholds is the ability to choose Turkey, not the ability to describe it.
 */
export const SPECIALTY_COUNTRIES: SpecialtyCountry[] = TURKIYE_ENABLED
  ? ALL_SPECIALTY_COUNTRIES
  : ['AU'];

export const COUNTRY_LABELS: Record<SpecialtyCountry, string> = {
  AU: 'Australia',
  TR: 'Turkey',
};
